export default "__VITE_ASSET__BHOb8pXf__ 400w";